import './DOM/closest';
import './DOM/matches';
import './DOM/toggleAttribute';
import './DOM/append';

import { queueMicrotaskPolyfill } from '@atomify/hooks';
queueMicrotaskPolyfill();

import 'array-flat-polyfill';
